/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





$(document).ready(function () {
  function isMobile() {
    return window.innerWidth <= 768
  }

  $(document).on("click", ".navlink--search", function (e) {
    if (!isMobile()) return
    e.preventDefault()
    $(".add_class").addClass("is-open")
  })

  $(document).on("click", ".search-popdown__close", function (e) {
    if (!isMobile()) return
    e.preventDefault()
    $(".add_class").removeClass("is-open")
  })





$(window).on('load', function () {
  setTimeout(function () {
    $('section#shopify-pc__banner').attr('style', 'display:block !important');
    $('div#PBarNextFrameWrapper').attr('style', 'display:block !important');
    $('.whatsapp-chat-area').attr('style', 'display:block !important');
  }, 12000);
});
})


document.addEventListener("theme:scroll", () => {
  const headerWrapper = document.querySelector("[data-header-wrapper]");

  const announcement = document.querySelector(
    '.shopify-section-group-group-header [data-section-type="announcement"]'
  );

  if (!headerWrapper || !announcement) return;

  if (headerWrapper.classList.contains("js__header__stuck")) {
    announcement.classList.add("sticky_annoument_bar");
  } else {
    announcement.classList.remove("sticky_annoument_bar");
  }
});